import saveSessionToSchedules from './save_session_to_schedules'
import saveScheduleNotifications from './save_schedule_notifications'

export default (expert, user, sessionLength, startTime, sessionId) => {
  return saveSessionToSchedules(expert, user, sessionLength, startTime, sessionId)
    .then(saveScheduleNotifications.bind(null, expert, user, sessionLength, startTime, sessionId))
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/setters/set_later_session_side_effects.js
 **/